import { edmCampaign } from '@bingads-webui/edm-campaign';

export const addAsset = (payload, cid, aid) => {
  const edmEntity = edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Folders['Default.AddAsset'];

  return edmEntity.$makeCall({ payload }).toPromise();
};
